import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=524dfc6e&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=524dfc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524dfc6e",
  null
  
)

export default component.exports